<template>
  <div>
    <menu-bar></menu-bar>
    <el-row :gutter="20" style="width: 1400px;margin: 0 auto">
      <el-col :span="14" :offset="5">
        <el-card style="margin-top: 24px">
          <div class="grid-content bg-purple" style="padding: 10px;display: flex">
            <div style="width: 30%;text-align: center">
              <div class="image-container" style="width: 215px;display: flex;align-items: center;justify-content: center;min-height: 142px">
                <img style="width: 185px" :src="itemData.iconUrl"/>
              </div>
            </div>
            <div style="width: 69%;margin-left: 1%;position: relative">
              <div style="font-weight: 600;font-size: 24px">
                {{ itemData.cnName }}
              </div>
              <div style="font-size: 18px">
                {{ itemData.engName }}
              </div>
              <div style="margin-top: 8px" :style="formatterRarity(itemData.rarityName)">
                {{ itemData.rarityName }}
              </div>
              <div style="position: absolute;bottom: 0px">
                <div style="margin-top: 8px;display: flex;align-items: center">
                  <div style="font-size: 18px;margin-right: 8px"> 最低售价</div>
                  <div class="text-color-orange mr-15 text-28" style="font-size: 24px;color: orange">
                    {{ platformData.length != 0 ? ('¥ ' + platformData[0].price.toFixed(3)) : '暂无数据' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="padding: 0 10px">
            <div v-show="similarItem.regularSkins.length != 0">
              <el-tag
                @click="showDailyTradeInfo(item.engName)"
                      :effect="$route.query.marketHashName === item.engName ? 'dark':'light'"
                      v-for="item of similarItem.regularSkins" key="item.label" type="info" style="margin-right: 8px;cursor: pointer;width: 135px;text-align: center">
                {{item.label}} {{item.minPrice == null ? '':item.minPrice.toFixed(2)}}
              </el-tag>
            </div>
            <div v-show="similarItem.statTrakSkins.length != 0" style="margin-top: 12px">
              <el-tag
                @click="showDailyTradeInfo(item.engName)"
                :effect="$route.query.marketHashName === item.engName ? 'dark':'light'"
                      v-for="item of similarItem.statTrakSkins" key="item.label" type="info" style="margin-right: 8px;cursor: pointer;width: 135px;text-align: center">
                {{item.engName.indexOf('Souvenir') !== -1 ? '纪念品':'暗金'}}
                {{item.label}} {{item.minPrice == null ? '':item.minPrice.toFixed(2)}}</el-tag>
            </div>

          </div>
        </el-card>
        <el-tabs style="margin-top: 12px" type="border-card" v-model="activeTab">
          <el-tab-pane label="历史走势" name="tradeHistory">
            <div id="priceEchartsContainer" style="height: 280px;margin-bottom: 8px"></div>
            <div id="detailEchartsContainer" style="height: 280px"></div>
          </el-tab-pane>
          <el-tab-pane label="平台数据" name="platformData">
            <el-table
              :data="platformData"
              style="width: 100%">
              <el-table-column
                prop="platform"
                width="160"
                label="来源">
                <template slot-scope="props">
                  <div style="color: #979cae;font-size: 16px;padding-left: 24px">{{ props.row.platform }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="price"
                label="售价">
                <template slot-scope="props">
                  {{ props.row.price == null ? '' : ('¥ ' + props.row.price.toFixed(3)) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="onSell"
                label="当前在售">
                <template slot-scope="props">
                  {{ (props.row.onSell == null || props.row.onSell == 0) ? '' : (props.row.onSell + '件') }}
                </template>
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="上次更新于">
              </el-table-column>
              <el-table-column
                prop="action"
                width="140px"
                label="">
                <template slot-scope="props">
                  <el-button size="small" type="primary" style="margin-right: 12px"
                             @click="routerChanger(props.row.router)">
                    前去购买
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {auditDailyInfo} from "../../api/api";
import * as echarts from "echarts";
import {formatterRarity} from "../../api/util";
import MenuBar from "../Menu/menuBar.vue";

export default {
  name: "itemPage",
  components: {MenuBar},
  data() {
    return {
      similarItem:{
        regularSkins:[],
        statTrakSkins:[]
      },
      itemData: {},
      activeTab: 'tradeHistory',
      detailEcharts: {},
      detailEchartsOption: {
        title: {
          text: '在售量 & 近期成交'
        },
        color: ['#5470C6', '#91CC75', '#EE6666', '#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        toolbox: {
          feature: {
            dataView: {show: true, readOnly: false},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        dataZoom: [
          {
            start: 0,
            end: 100
          }
        ],
        legend: {
          data: ['steam日成交', 'steam在售', '第三方在售']
        },
        xAxis: {
          type: 'time',
          axisTick: {
            alignWithLabel: true
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '在售量',
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#5470C6'
              }
            },
            axisLabel: {
              formatter: '{value} 件'
            }
          },
          {
            type: 'value',
            name: 'steam日成交',
            position: 'right',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#91CC75'
              }
            },
            axisLabel: {
              formatter: '{value} 件'
            }
          }
        ],
        series: [
          {
            name: 'steam在售',
            type: 'bar',
            barWidth: '10',
            stack: 'onSellNumber',
            data: [
              2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
            ]
          },
          {
            name: '第三方在售',
            type: 'bar',
            barWidth: '10',
            stack: 'onSellNumber',
            itemStyle: {
              color: '#3398DB'
            },
            data: [
              2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
            ]
          },
          {
            name: 'steam日成交',
            symbolSize:0,
            type: 'line',
            yAxisIndex: 1,
            data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
          }
        ]
      },
      priceEcharts: {},
      priceEchartsOptions: {
        title: {
          text: '价格走势'
        },
        legend: {
          selected: {
            '参考价': true
          },
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: {readOnly: false},
            magicType: {type: ['line', 'bar']},
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis:  {
          type: 'time',
          axisTick: {
            alignWithLabel: true
          },
        },
        yAxis: {
          type: 'value',
          scale: true, // 关键优化：开启自动缩放，刻度贴合数据范围
        },
        dataZoom: [
          {
            start: 0,
            end: 100
          }
        ],
        series: [
          {
            name: '参考价',
            symbolSize:0,
            data: [],
            type: 'line',
            smooth: true
          }
        ]
      },
      platformData: []
    }
  },
  mounted() {
    this.loadItemData()
  },
  methods: {
    showDailyTradeInfo(engName) {
      let routeUrl = this.$router.resolve({
        path: "/itemPage",
        query: {marketHashName: engName}
      });
      window.open(routeUrl.href, '_blank');
    },
    formatterRarity(val) {
      return formatterRarity(val)
    },
    loadItemData() {
      this.detailEcharts = echarts.init(document.getElementById('detailEchartsContainer'), null, {locale: 'ZH'})
      this.detailEcharts.showLoading();

      this.priceEcharts = echarts.init(document.getElementById('priceEchartsContainer'), {locale: 'ZH'})
      this.priceEcharts.showLoading();
      auditDailyInfo({
        engName: this.$route.query.marketHashName
      }).then(json => {
        this.itemData = json.data.itemData
        this.platformData = json.data.platformData
        this.similarItem.regularSkins = json.data.similarItem.regularSkins || []
        this.similarItem.statTrakSkins = json.data.similarItem.statTrakSkins || []
        this.$nextTick(_ => {
          this.$set(this.detailEchartsOption.series[0], 'data', json.data.steamOnSells || [])
          this.$set(this.detailEchartsOption.series[1], 'data', json.data.thirdOnSells || [])
          this.$set(this.detailEchartsOption.series[2], 'data', json.data.steamVolumes || [])
          this.detailEcharts.setOption(this.detailEchartsOption);
          this.detailEcharts.hideLoading()

          this.$set(this.priceEchartsOptions.series[0], 'data', json.data.thirdMinPrices || [])
          // this.$set(this.priceEchartsOptions.series[1], 'data', json.data.steamBuyerPrices || [])
          this.priceEcharts.setOption(this.priceEchartsOptions);
          this.priceEcharts.hideLoading()
        })
      })
    },
    routerChanger(url) {
      window.open(url)
    },
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  text-align: center;
  background: url(../HomePage/background.jpg) 50% no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/ui/itemPage/index.vue